import { render, staticRenderFns } from "./dateElement.vue?vue&type=template&id=38741cc8&scoped=true"
import script from "./dateElement.vue?vue&type=script&lang=js"
export * from "./dateElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38741cc8",
  null
  
)

export default component.exports